import {h, Fragment} from "preact"
import { useAppState, useFacets, useProductFilters } from "@nosto/preact"
import SelectedFilters from "./SelectedFilters"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"

import { sortSizeData } from "../helpers"
import { facetValueOrder } from "../config"

export default function SideBar({ sidebarOpen, toggleSidebar }) {
    const { response: { products } } = useAppState();
    const { loading, facets } = useFacets()
    const { filters, removeAll } = useProductFilters();
    const docCount = products?.total ?? 0;

    return facets?.length > 0 ? (
        <>
            <aside
                id="ns-sidebar"
                className="ns-fixed ns-flex ns-flex-col"
                aria-label="Filter options"
                aria-expanded={sidebarOpen}
                aria-hidden={!sidebarOpen}
                inert={!sidebarOpen}
            >
                {/* HEADER */}
                <div className="ns-sidebar__header ns-relative">
                    <div className="ns-sidebar__header-wrap ns-flex ns-items-center ns-flex-nowrap">
                        <h3 className="ns-sidebar__heading">Filter By</h3>

                        {filters.length > 0 && (
                            <button
                                className="ns-sidebar__clear-active-filters"
                                aria-label="Remove all active filters"
                                type="button"
                                onClick={removeAll}
                            >
                                Clear All
                            </button>
                        )}
                    </div>

                    <button
                        className="ns-sidebar__close-btn"
                        type="button"
                        aria-label="Close filter list"
                        aria-controls="ns-sidebar"
                        onClick={toggleSidebar}
                    >
                        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 18 18" width="15px" height="15px">
                            <title>Close Filters</title>
                            <path d="M9.70728,9L17.854,.85352c.19531-.19531,.19531-.51172,0-.70703s-.51172-.19531-.70703,0L9.00024,8.29297,.85352,.14648C.6582-.04883,.3418-.04883,.14648,.14648S-.04883,.6582,.14648,.85352L8.29321,9,.14648,17.14648c-.19531,.19531-.19531,.51172,0,.70703,.09766,.09766,.22559,.14648,.35352,.14648s.25586-.04883,.35352-.14648L9.00024,9.70703l8.14673,8.14648c.09766,.09766,.22559,.14648,.35352,.14648s.25586-.04883,.35352-.14648c.19531-.19531,.19531-.51172,0-.70703L9.70728,9Z" fill="currentColor"></path>
                        </svg>
                    </button>
                    <SelectedFilters />
                </div>
                
                {/* CONTENT */}
                <div className="ns-sidebar__body ns-overflow-hidden ns-overflow-y-auto">
                    <ul className="ns-sidebar__body-facet-list">
                        {facets?.map(facet => {
                            if(facet.type === 'terms') {
                                if(facetValueOrder[facet.name]) {
                                    sortSizeData(facet)
                                }
                                return (<Facet facet={facet} key={facet.field} />)
                            } else if (facet.type === 'stats') {
                                return (<RangeFacet facet={facet} key={facet.field} />)
                            } else {
                                return null;
                            }
                        })}
                    </ul>
                </div>

                {/* FOOTER */}
                <div className="ns-sidebar__footer ns-flex ns-items-center ns-justify-center">
                    <button
                        className="ns-sidebar__footer-view-results-btn"
                        type="button"
                        aria-label="View Results"
                        onClick={toggleSidebar}
                    >
                        View Results ({docCount})
                    </button>
                </div>
            </aside>

            {/* backdrop */}
            <div
                className="ns-sidebar__backdrop"
                aria-label="Close filters list"
                aria-controls="ns-sidebar"
                role="button"
                tabIndex="0"
                onClick={toggleSidebar}
            ></div>
        </>
    ) : ( '' )
}
